import React, { useEffect, useState } from 'react'
import { Request } from '../../hooks/Request';
import { Anchor } from '../../components/Text';
import Select from "react-select";
import { Button } from '../../components/Buttons';
import { useDialog } from '../../contexts/DialogContext';
import { validateArray } from '../../utils/validate';
import H3, { H3Custom } from '../../components/Text/H3';
import TableComplete from '../../components/Tables/TableComplete';
import { mapIcons } from '../../utils/constant';
import FormAddPaymentReq from './FormAddPaymentReq';
import { Tooltip } from 'react-tippy';
import { DialogConfirmation } from '../../components/Modal';
import { Badge } from '../../components/Badge/Badge';

export const AddSubPaymentReqForm = ({
    item,
    reload,
    onClose,
    permissions,
    rol
}) => {
    const permissionField = { ...permissions, fields: permissions.fields.filter(x => x.rols.includes(rol)) };
    const [selectValue, setSelectValue] = useState('')
    const [tableTitleOpts, setTableTitleOpts] = useState([])
    const { data: fieldOpts } = Request({
        urlApi: `dropdown/${item?.procedureTypeId === 1 ? 'documentos-para-solicitudes-de-importacion' : 'documentos-para-solicitudes-de-exportacion'}/options`,
    });
    const { data, call } = Request({
        urlApi: `procElement/${item.id}/subElements`
    });

    const { openDialog, dialogClose } = useDialog()

    useEffect(() => {
        if (data) {
            setTableTitleOpts([...new Set(data.map(item => item.label))]);
        }
    }, [data])

    function generateFormAdd(data, onClose, reload, fieldOpts, fieldlabel = null) {
        const commonProps = {
            data,
            onClose,
            allowEmpty: true,
            reload,
            initVals: { ...data, mainProcElementId: item.id, label: data?.label ? data?.label : options?.find((opt) => opt.value === selectValue)?.label },
            formFields: validateArray(permissionField?.fields) ? permissionField?.fields?.filter(x => x.formConfig === true) : [],
            refFileIndex: permissionField?.openUrl
        };

        if (selectValue) {
            return (
                <FormAddPaymentReq
                    {...commonProps}
                    addTitle={fieldOpts?.find(f => f.id + '' === selectValue)?.label ?? fieldlabel}
                    reload={() => {
                        reload();
                        setSelectValue('');
                    }}
                />
            );
        } else {
            return <FormAddPaymentReq {...commonProps} />;
        }
    }

    function handleForm(data) {
        const parsedDetails = data.details ? JSON.parse(data.details) : [];
        const formattedData = {
            ...data,
            ...parsedDetails
        };
        openDialog(generateFormAdd(formattedData, dialogClose, call, null, data.fieldlabel));
    }

    const HandleCreateForm = () => {
        if (selectValue !== "") {
            openDialog(generateFormAdd(data, dialogClose, () => { call(); reload() }, fieldOpts));
        }
    };

    function handleDelete(data) {
        openDialog(
            <DialogConfirmation
                children={<H3>¿Estas seguro que quieres eliminar el archivo?</H3>}
                onClose={dialogClose}
                method="delete"
                url={`/procElement/${data.id}`}
                texBtn="Eliminar"
                handleSuccess={() => {
                    call()
                    reload()
                }}
            />
        );
    }
    function handleStatusUpdate(data) {
        // let status = data.status === "Validado" ? null : "Validado";
        openDialog(
            <DialogConfirmation
                children={<H3>¿Estas seguro que quieres eliminar el archivo?</H3>}
                onClose={dialogClose}
                method="patch"
                url={`/procElement/${data.id}/changeStatus`}
                texBtn="Modificar"
                handleSuccess={() => {
                    call()
                    reload()
                }}
            />
        );
    }

    const options = fieldOpts?.map((opt) => ({
        value: opt.id,
        label: opt.name,
    }));


    return (
        <div className="flex flex-col gap-2">
            <span className="my-[10px] font-bold text-lg" >
                SOLICITUDES DEL TRÁMITE <span className='text-red-500'>{item.stringNumber}</span>
            </span>
            <div>
                <Select
                    name="FieldId"
                    value={options?.find((opt) => opt.value === selectValue) || null}
                    onChange={(selectedOption) => setSelectValue(selectedOption?.value || '')}
                    options={options ?? []}
                    placeholder="Seleccionar tipo de documento"
                    isClearable
                />

                {
                    selectValue !== "" &&
                    <Button
                        onClick={() => HandleCreateForm()}
                        className="py-2 mt-1 w-full"
                    >
                        Adicionar documento
                    </Button>
                }
            </div>
            <div className="overflow-auto flex flex-col gap-3 pt-4">
                {data && (
                    tableTitleOpts?.map((fieldname, index) => {
                        const modifiedData = data?.map(datai => {
                            const parsedDetails = datai.details
                                ? (typeof datai.details === 'string' ? JSON.parse(datai.details) : datai.details)
                                : [];

                            return {
                                ...datai,
                                ...parsedDetails
                            };
                        });

                        return data.filter(x => x.label === fieldname)?.length > 0 && (
                            <div className="bg-stone-400/20 shadow-sm shadow-stone-400 p-2 rounded-md">
                                <H3Custom className="text-start mb-1 text-sm font-semibold">{fieldname}</H3Custom>
                                <TableComplete
                                    header={[
                                        ...(
                                            validateArray(permissionField?.fields) ?
                                                permissionField?.fields?.filter(x => x.tableConfig === true)?.map((tableItem) => (
                                                    tableItem.type === "custom" ?
                                                        tableItem.name === permissionField?.openUrl ?
                                                            {
                                                                name: tableItem.name,
                                                                label: "Enlace",
                                                                type: "custom",
                                                                builder: (item) => {
                                                                    if (item) {
                                                                        return (
                                                                            <Anchor
                                                                                href={item}
                                                                                className="text-[#1d4ed8] underline"
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                Abrir
                                                                            </Anchor>
                                                                        );
                                                                    } else {
                                                                        return "-";
                                                                    }
                                                                },
                                                            }
                                                            :
                                                            {
                                                                name: tableItem.name,
                                                                label: tableItem.label,
                                                                type: "custom",
                                                                builder: (item) => {
                                                                    return (
                                                                        <>
                                                                            <div className='flex'>
                                                                                <Badge data={item === true ? "approved" : "pending"} className='text-xs px-2 py-1' />
                                                                            </div>
                                                                        </>
                                                                    );
                                                                },
                                                            }
                                                        :
                                                        tableItem
                                                ))
                                                :
                                                []
                                        ),
                                        {
                                            name: "add",
                                            type: "action",
                                            label: "Opciones",
                                            sticky: true,
                                            actions: [
                                                {
                                                    label: "Editar",
                                                    icon: "fas fa-edit",
                                                    action: handleForm,
                                                    color: "text-[#1d4ed8]",
                                                },
                                                ...(
                                                    permissionField?.changeStatus?.includes(rol) ?
                                                        [
                                                            {
                                                                icon: "fas fa-trash",
                                                                builder: (item) => {
                                                                    if (item) {
                                                                        return (
                                                                            <div
                                                                                className={` text-xl cursor-pointer`}
                                                                                onClick={() => handleStatusUpdate(item)}
                                                                            >
                                                                                <Tooltip
                                                                                    title={'Cambiar estado'}
                                                                                    position="right"
                                                                                    trigger="mouseenter"
                                                                                >
                                                                                    {mapIcons(item.check ? "approved" : "pending")}
                                                                                </Tooltip>
                                                                            </div>
                                                                        );
                                                                    } else {
                                                                        return "-";
                                                                    }
                                                                },
                                                            },
                                                        ]
                                                        :
                                                        []
                                                ),
                                                ...(
                                                    permissionField?.openUrl ?
                                                        [
                                                            {
                                                                icon: "fas fa-trash",
                                                                builder: (item) => {
                                                                    if (item) {
                                                                        return (
                                                                            <Tooltip
                                                                                title={'Abrir'}
                                                                                position="right"
                                                                                trigger="mouseenter"
                                                                            >
                                                                                <Anchor
                                                                                    href={item[permissionField?.openUrl]}
                                                                                    className={`${item[permissionField?.openUrl] && item[permissionField?.openUrl] !== null && item[permissionField?.openUrl] !== '' ? 'text-[#1d4ed8]' : 'text-gray-400'} text-lg`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <i className="far fa-file-pdf" />
                                                                                </Anchor>
                                                                            </Tooltip>
                                                                        );
                                                                    } else {
                                                                        return "-";
                                                                    }
                                                                },
                                                            }
                                                        ] :
                                                        []
                                                ),
                                                {
                                                    label: "Eliminar",
                                                    icon: "fas fa-trash",
                                                    action: handleDelete,
                                                    color: "text-red-500",
                                                },
                                            ],
                                        },
                                    ]}
                                    data={
                                        modifiedData.filter(x => x.label === fieldname)
                                    }
                                />
                            </div>
                        )
                    }

                    )
                )}
            </div>

        </div>
    )
}
